import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/tag-center/stats/")({
  validateSearch: (search: Record<string, unknown>): { ns?: string } => {
    return typeof search.ns === "string" && search.ns ? { ns: search.ns } : {};
  },
  component: LegacyStatsRedirect,
});

/** 使用分析已并入分析中心（header 子 Tab：使用/影响/质量） */
function LegacyStatsRedirect() {
  const { ns } = Route.useSearch();
  return <Navigate to="/semantic-platform/data-governance/analysis" search={{ tab: "usage", ...(ns ? { ns } : {}) }} replace />;
}
